import { isRunTime } from "./isRunTime";
import { findKey } from "./lodash";

const BROWSER = {
    messenger: /\bFB[\w_]+\/(Messenger|MESSENGER)/,
    facebook: /\bFB[\w_]+\//,
    twitter: /\bTwitter/i,
    line: /\bLine\//i,
    wechat: /\bMicroMessenger\//i,
    puffin: /\bPuffin/i,
    miui: /\bMiuiBrowser\//i,
    instagram: /\bInstagram/i,
    chrome: /Chrome\/[.0-9]* (Mobile)?/,
    safari: /Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari/,
    ie: /IEMobile|MSIEMobile/,
    firefox: /fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS/,
    ios: /iPhone|iPod|iPad/,
};

let isMobileCache: boolean | null = null;

export function isMobile(): boolean {
    // Return cached result if available
    if (isMobileCache !== null) {
        return isMobileCache;
    }

    if (!isRunTime()) {
        return false;
    }

    // Method 1: CSS media query check
    if (window.matchMedia) {
        const mediaQuery = window.matchMedia('(max-width: 767px), (pointer: coarse)');
        if (mediaQuery.matches) {
            isMobileCache = true;
            return true;
        }
    }

    // Method 2: User agent check
    const ua = window.navigator.userAgent.toLowerCase();
    const mobileKeywords = [
        'mobile', 'android', 'iphone', 'ipod', 'ipad',
        'blackberry', 'webos', 'windows phone',
        'opera mini', 'opera mobi', 'iemobile'
    ];

    for (const keyword of mobileKeywords) {
        if (ua.indexOf(keyword) > -1) {
            isMobileCache = true;
            return true;
        }
    }

    // Method 3: Screen size check
    if (window.screen && window.screen.width < 768) {
        isMobileCache = true;
        return true;
    }

    // Method 4: Touch capability check
    if ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) {
        isMobileCache = true;
        return true;
    }

    isMobileCache = false;
    return false;
}

export function whichBrowser() {
    return isRunTime()
        ? findKey(BROWSER, regex => regex.test(window.navigator.userAgent)) || 'other'
        : 'other';
}
